module.exports = __webpack_public_path__ + "e43c113578ec1637337b5fae780f9528.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-16.png
// module id = 1698
// module chunks = 0